export default {"src":"/_next/static/media/portal.80411b2b.svg","height":1994,"width":2560,"blurWidth":0,"blurHeight":0};